module.exports = __webpack_public_path__ + "0b10207d8b5efce24fe1490e5afa91fb.jpg";